// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"cebcf5d3","977":"e858014b"}[chunkId] + ".chunk.js";
};